module.exports = __webpack_public_path__ + "static/media/funnel.48cc2c36.svg";